import { createContext, useContext } from 'react';

const dark = {
  theme: 'dark',
  preference: 'dark',
  setPreference: (_preference) => {},
  toggle: () => {},
};

const ThemeContext = createContext(dark);

export function useTheme() {
  return useContext(ThemeContext);
}

/** The draft landing page stays dark. The workspace pattern reads this. */
export function ThemeProvider({ children }) {
  return <ThemeContext.Provider value={dark}>{children}</ThemeContext.Provider>;
}
